import ContractorInvoiceResource from "./contractorInvoice.resource";

const contractorInvoiceModule = angular
  .module("app.resources.contractorInvoice", [])
  .service("ContractorInvoice", ContractorInvoiceResource);

export default contractorInvoiceModule;



// WEBPACK FOOTER //
// ./src/resources/contractorInvoice/contractorInvoice.module.js